// Icons
import { ReactComponent as MainLogo } from './logo.svg'

// Icons
import { ReactComponent as AngleRight } from './icons/angle-right.svg'
import { ReactComponent as Email } from './icons/email.svg'
import { ReactComponent as ExtractedEmail } from './icons/extracted-email.svg'
import { ReactComponent as Inspiration } from './icons/inspiration.svg'
import { ReactComponent as Access } from './icons/access.svg'
import { ReactComponent as Skips } from './icons/skips.svg'
import { ReactComponent as WorldOfInspirers } from './icons/world-of-inspirers.svg'
import { ReactComponent as Unlock } from './icons/unlock.svg'
import { ReactComponent as Support } from './icons/support.svg'
import { ReactComponent as LogoWithAppStore } from './icons/app-store.svg'

const Logo = () => {
  return (
    <div className="center">
      <MainLogo width="146" height="100" />
    </div>
  )
}

const AppStore = () => {
  return (
    <div className="center">
      <LogoWithAppStore width="190" height="160" />
    </div>
  )
}

export {
  Logo,
  AngleRight,
  Email,
  ExtractedEmail,
  Inspiration,
  Access,
  Skips,
  WorldOfInspirers,
  Unlock,
  Support,
  AppStore,
}
